// extracted by mini-css-extract-plugin
module.exports = {"small":"small__2Hf7H"};